'use client'

// React Imports
import { useState } from 'react'
import type { ReactNode } from 'react'

// MUI Imports
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'

// Component Imports
import CustomTextField from '@core/components/mui/TextField'

// A password input with a per-field reveal toggle (Luca 2026-07-13), shared by the
// self-service change dialog and the admin user management.
const PasswordField = ({
  label,
  value,
  onChange,
  ariaLabel,
  autoComplete,
  error,
  helperText
}: {
  label: string
  value: string
  onChange: (value: string) => void
  ariaLabel: string
  autoComplete: string
  error?: boolean
  helperText?: ReactNode
}) => {
  const [show, setShow] = useState(false)

  return (
    <CustomTextField
      fullWidth
      type={show ? 'text' : 'password'}
      autoComplete={autoComplete}
      label={label}
      value={value}
      onChange={e => onChange(e.target.value)}
      error={error}
      helperText={helperText}
      slotProps={{
        htmlInput: { 'aria-label': ariaLabel },
        input: {
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton
                size='small'
                edge='end'
                aria-label={`toggle-${ariaLabel}`}
                onClick={() => setShow(prev => !prev)}
                onMouseDown={e => e.preventDefault()}
              >
                <i className={show ? 'tabler-eye-off' : 'tabler-eye'} />
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  )
}

export default PasswordField
